/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit } from '@angular/core';
import { ActionSheetController, AlertController, IonContent, IonRouterOutlet, LoadingController, ModalController, NavParams, Platform, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { FcmService } from '@shared/services/fcm.service';
import { EventService } from '@shared/services/event.service';
import { Haptics } from '@capacitor/haptics';
import { UserService } from '@shared/services/user.service';
import { UtilService } from '@shared/utils/util';
import { getDietSinceElapsed } from '@shared/utils/dateUtils';
import { Preferences } from '@capacitor/preferences';
import { EmailValidationPage } from '../email-validation/email-validation.page';
import { RecadinhoPage } from '../recadinho/recadinho.page';
import { ComplimentModalComponent } from '@shared/components/compliment-modal/compliment-modal.component';
import { ResetPasswordPage } from '../reset-password/reset-password.page';
import { ProfilePage } from '../profile/profile.page';
import { Subscription } from 'rxjs';
import { PicturesPage } from '../pictures/pictures.page';
import { ChatPage } from '../chat/chat.page';
import { MatchService } from 'src/app/services/match.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { PurchaseService } from 'src/app/services/purchase.service';
import { SuperLikeModalComponent } from '@shared/components/superlike-modal/superlike-modal.component';
import { VegMatchPage } from '../veg-match/veg-match.page';

import { ChangeDetectorRef, ElementRef, ViewChild } from '@angular/core';
import type { GestureDetail } from '@ionic/angular';
import { GestureController } from '@ionic/angular';
import { ShareProfileComponent } from '@shared/components/share-profile/share-profile.component';
import { ChangeProfilePhotoComponent } from '@shared/components/change-profile-photo/change-profile-photo.component';
import { ProfileAlreadyValidatedComponent } from '@shared/components/profile-already-validated/profile-already-validated.component';
import { ValidateProfileComponent } from '@shared/components/validate-profile/validate-profile.component';
import { AvocadoModalComponent } from '@shared/components/avocado-modal/avocado-modal.component';
import { SliderState, SliderControlComponent } from '@shared/components/slider-control/slider-control.component'

@Component({
  selector: 'app-profile-display',
  templateUrl: './profile-display.page.html',
  styleUrls: ['./profile-display.page.scss'],
  providers: [UserService, UtilService, FcmService, IonRouterOutlet]
})
export class ProfileDisplayPage implements OnInit {
  public myForm: any;
  public userData: any;
  public profileUserId: string = '';
  public me: any;
  public howOthersSeeMe: boolean = false;
  public pictures: any = [];
  /** TESTE (veggly): a foto principal vira o visualizador da galeria. Índice da foto ATIVA
   *  exibida no topo. Default = 1ª foto (index 0); muda ao tocar numa miniatura abaixo dela. */
  public galleryIndex = 0;
  public photoHintDirection: 'next' | 'prev' | null = null;
  private photoHintShown = { next: false, prev: false };
  private photoHintTimer: ReturnType<typeof setTimeout> | null = null;
  private readonly photoHintStorageKey = 'profilePhotoNavHintShown';
  private photoHintAlreadySeenOnDevice = this.readStoredPhotoHint();
  /** true = mostra a foto inteira (object-fit contain, sem o corte 4:5); false = 4:5 cropado. */
  public fitContain = false;
  /** Só mostra o botão "ver foto inteira" para fotos do formato ANTIGO (não-4:5). Fotos novas
   *  já sobem cropadas em 4:5 → o corte não esconde nada → botão desnecessário. */
  public activePhotoIsLegacy = false;
  /** Cache do "formato antigo" por índice de foto (cada foto tem status próprio). */
  public pictureIsLegacy: boolean[] = [];
  /** Indica que a tira de miniaturas ainda tem fotos à direita para rolar (mostra o indicador). */
  public thumbsHasMore = false;
  /** Lazy loading das miniaturas: thumbLoaded[i] = true quando a miniatura i carregou (esconde o skeleton). */
  public thumbLoaded: boolean[] = [];
  public userHasPicture: boolean = false;
  public gender: any = null;
  public diet = null;
  public timeElapsed = '';
  public timeUnit = '';
  public age: any;
  public dietTextSize: number = 0;
  public lastSeenTextSize: number = 0;
  public superLikeMsg: string | any = null;
  public liked: boolean = false;
  // Marca que um Elogio foi enviado nesta sessão do perfil — sinaliza ao chat (via role no
  // dismiss) que ele precisa recarregar as mensagens para exibir o elogio recém-enviado.
  private recadinhoSent: boolean = false;
  public isAndroid: boolean = false;
  private isNative: boolean = true;
  // @ViewChild(Slides) slides: Slides;
  // @ViewChild(Content) content: Content;
  public superLikedList: any = [];
  public sliderReady: boolean = false; // Flag para controlar quando o slider deve ser renderizado

  @ViewChild(IonContent, { read: ElementRef }) content: ElementRef | any;
  @ViewChild('debug', { read: ElementRef }) debug: ElementRef<HTMLParagraphElement> | any;
  @ViewChild('photoRef', { read: ElementRef }) photoRef!: ElementRef<HTMLElement>;
  @ViewChild('sliderRef') sliderComponent!: SliderControlComponent;
  @ViewChild('thumbStrip') thumbStripRef?: ElementRef<HTMLElement>;
  /** ResizeObserver da tira de miniaturas: recalcula a setinha "há mais fotos" após o layout. */
  private thumbRO?: ResizeObserver;
  public selfiesApproved: boolean = false;
  public backButton: Subscription | any;
  private unregisterFunction: any;

  constructor(
    private platform: Platform,
    private router: Router,
    private route: ActivatedRoute,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    private userService: UserService,
    private util: UtilService,
    private translate: TranslateService,
    private alertCtrl: AlertController,
    private matchService: MatchService,
    private params: NavParams,
    private analytics: AnalyticsService,
    private purchaseServiceProvider: PurchaseService,
    private el: ElementRef,
    private gestureCtrl: GestureController,
    private cdRef: ChangeDetectorRef,
    public toastCtrl: ToastController,
    public actionSheetCtrl: ActionSheetController,
    private eventService: EventService
  ) {

    try {
      this.isNative = this.util.isNative();
    } catch (error) {
      // ignore error        
    }

    this.platform.ready().then(() => {
      this.isAndroid = this.platform.is('android');
      this.isNative = this.util.isNative();
    });

    if (this.params.get('theSoul')) {
      this.userData = this.params.get('theSoul');
      this.superLikeMsg = this.params.get('msg');
      console.log('userData: ' + JSON.stringify(this.userData));

      interface UserData {
        _id: { $oid: string };
        superLikedSouls?: Array<{ receivingSoul: { $oid: string } }>;
      }

      Preferences.get({ key: 'USER_DATA' }).then((val) => {
        const userData: UserData | null = val.value ? JSON.parse(val.value) as UserData : null;

        this.me = userData;
        this.userHasPicture = this.userService.checkUserHasPicture(this.me);

        if (userData?.superLikedSouls) {
          for (const i in userData.superLikedSouls) {
            this.superLikedList[i] = userData.superLikedSouls[i].receivingSoul.$oid;
          }
        } else {
          this.superLikedList = [];
        }

        try {
          this.howOthersSeeMe = this.me?._id.$oid === this.userData?._id.$oid;
          
          // Inicializa o estado do slider corretamente
          // Usa a mesma lógica do feed: verifica se está na superLikedList
          if (this.userData && !this.userData.match) {
            const isSuperLiked = this.superLikedList.includes(this.userData._id.$oid);
            const isLiked = this.userData.alreadyLiked;
            
            if (isSuperLiked) {
              // Prioriza super like sobre like (super like também marca como liked)
              this.userData.sliderState = SliderState.SUPERLIKE;
            } else if (isLiked) {
              this.userData.sliderState = SliderState.LIKE;
            } else {
              this.userData.sliderState = SliderState.IDLE;
            }
            
            // Marca o slider como pronto para ser renderizado após um pequeno delay
            // Isso garante que o sliderState está definido antes do componente ser criado
            setTimeout(() => {
              this.sliderReady = true;
              this.cdRef.detectChanges();
            }, 0);
          }
          
          if (this.howOthersSeeMe) {
            this.loadMyImages();
          } else {
            this.preparePhotos();
          }

          this.loadView();

        } catch (e) {
          console.error("Error processing profile display page logic: ", e);
        }
      });


    }

    if (this.params.get('profileUserId')) {
      (async () => {
        const loader = this.loadingCtrl.create({
          message: this.translate.instant('pleaseWait'),
          duration: 2000
        });

        (await loader).present();

      });

      this.profileUserId = this.params.get('profileUserId');
      Preferences.get({ key: 'USER_DATA' }).then((val: any) => {
        val = val.value ? JSON.parse(val.value) : null;

        if (val == null) {
          this.router.navigateByUrl('/login');
          return;
        } else if (val.needsEmailValidation) {
          this.modalCtrl.create({ component: EmailValidationPage }).then((modal) => {
            modal.present();
            return;
          });
        } else if (val.needsPasswordReset) {
          this.modalCtrl.create({ component: ResetPasswordPage }).then((modal) => {
            modal.present();
            return;
          });
        } else {
          this.me = val;
          const isFirstSetup: boolean = this.me.interest == null && this.me.interest2 == null;

          if (isFirstSetup) {
            this.modalCtrl.create({ component: ProfilePage }).then((modal) => {
              modal.present();
              return;
            });
          }
          if (this.params.get('profileUserId')) {
            this.userService.viewProfile(this.params.get('profileUserId'), this.me).subscribe(data => {
              localStorage.setItem('otherUser', data)
              this.userData = JSON.parse(data);

              this.howOthersSeeMe = this.me._id.$oid == this.userData?._id.$oid;
              try {
                this.howOthersSeeMe = this.me._id.$oid == this.userData?._id.$oid
                
                // Inicializa o estado do slider corretamente
                if (this.userData && !this.userData.match) {
                  // Usa a mesma lógica do feed: verifica se está na superLikedList
                  const isSuperLiked = this.superLikedList.includes(this.userData._id.$oid);
                  const isLiked = this.userData.alreadyLiked;
                  
                  if (isSuperLiked) {
                    // Prioriza super like sobre like (super like também marca como liked)
                    this.userData.sliderState = SliderState.SUPERLIKE;
                  } else if (isLiked) {
                    this.userData.sliderState = SliderState.LIKE;
                  } else {
                    this.userData.sliderState = SliderState.IDLE;
                  }
                  
                  // Marca o slider como pronto para ser renderizado após um pequeno delay
                  setTimeout(() => {
                    this.sliderReady = true;
                    this.cdRef.detectChanges();
                  }, 0);
                }
                
                if (this.howOthersSeeMe) {
                  this.loadMyImages();
                } else {
                  this.preparePhotos();
                }

                this.loadView();

              } catch (e) {
                // ignore. just keep as false
              }




            })
          }
        }
      })
      // maybe record like, super like etc
    }


    (async () => {
      if (this.superLikeMsg != null && this.superLikeMsg.length > 0 && this.superLikeMsg != 'undefined') {
        const alert = this.alertCtrl.create({
          header: this.translate.instant('messageOnSuperLike'),
          message: this.superLikeMsg,
          buttons: [
            {
              text: 'OK'
            }
          ]
        });
        (await alert).present();
      }
    })();
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    // Prevenir arrasto de imagens no Android 15
    if (this.isAndroid) {
      this.preventImageDrag();
    }
    
    const gesture = this.gestureCtrl.create({
      el: this.content.nativeElement,
      canStart: (detail) => this.canStartSlideBack(detail),
      onStart: () => this.onStart(),
      // onMove: (detail) => this.onMove(detail),
      onEnd: (detail) => this.onEnd(detail),
      gestureName: 'slide-right',
    }, true);

    gesture.enable();

    // Inicializa o slider após a view estar totalmente inicializada
    // Isso é crítico para garantir que funcione na primeira vez
    setTimeout(() => {
      this.initializeSliderState();
    }, 100);
    
    setTimeout(() => {
      this.initializeSliderState();
    }, 300);
    
    setTimeout(() => {
      this.initializeSliderState();
    }, 500);
  }
  
  /**
   * Previne o arrasto de imagens no Android 15
   * Adiciona listeners para prevenir dragstart e touchmove que causam arrasto
   */
  private preventImageDrag(): void {
    // Aguarda um pouco para garantir que os elementos estejam renderizados
    setTimeout(() => {
      const images = this.el.nativeElement.querySelectorAll('img');
      const pinchZoomElements = this.el.nativeElement.querySelectorAll('pinch-zoom');
      const loadingSpinners = this.el.nativeElement.querySelectorAll('app-loading-spinner');
      
      // Prevenir dragstart em todas as imagens
      images.forEach((img: HTMLElement) => {
        img.setAttribute('draggable', 'false');
        img.addEventListener('dragstart', (e) => {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }, { passive: false });
      });
      
      // Prevenir dragstart nos elementos pinch-zoom
      pinchZoomElements.forEach((el: HTMLElement) => {
        el.setAttribute('draggable', 'false');
        el.addEventListener('dragstart', (e) => {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }, { passive: false });
      });
      
      // Prevenir dragstart nos componentes loading-spinner
      loadingSpinners.forEach((el: HTMLElement) => {
        el.setAttribute('draggable', 'false');
        const buttons = el.querySelectorAll('button');
        buttons.forEach((btn: HTMLElement) => {
          btn.setAttribute('draggable', 'false');
          btn.addEventListener('dragstart', (e) => {
            e.preventDefault();
            e.stopPropagation();
            return false;
          }, { passive: false });
        });
      });
    }, 100);
  }
  
  /**
   * Não inicia o gesto de "voltar" (slide-right) quando o toque começa sobre a
   * tira de miniaturas — ali o arraste horizontal serve para rolar as fotos.
   */
  private canStartSlideBack(detail: GestureDetail): boolean {
    const target = detail?.event?.target as HTMLElement | undefined;
    return !target?.closest?.('.thumb-strip');
  }

  /** Recalcula se a tira de miniaturas ainda tem conteúdo à direita para rolar. */
  public updateThumbsHasMore(): void {
    // Busca a tira pelo ViewChild ou direto no DOM (fallback) — não depende do timing
    // de resolução do @ViewChild.
    const el = this.thumbStripRef?.nativeElement
      ?? (this.el?.nativeElement?.querySelector('.thumb-strip') as HTMLElement | null);
    if (!el) {
      this.thumbsHasMore = false;
      return;
    }
    // Largura visível = a do wrapper que restringe (fallback p/ a própria tira).
    const wrap = el.parentElement as HTMLElement | null;
    const visible = wrap?.clientWidth || el.clientWidth;
    const atEnd = el.scrollLeft + visible >= el.scrollWidth - 4;
    this.thumbsHasMore = el.scrollWidth > visible + 4 && !atEnd;
  }

  /** Lazy loading: marca a miniatura i como carregada (esconde o skeleton) e recalcula a setinha. */
  public onThumbLoad(i: number): void {
    this.thumbLoaded[i] = true;
    this.updateThumbsHasMore();
  }

  /** Liga (uma vez) um ResizeObserver na tira p/ recalcular a setinha após o layout,
   *  sem depender de timing (o 1º callback já dispara com as dimensões reais) e ao
   *  redimensionar a tela. Robusto a muitas fotos / miniaturas que carregam devagar. */
  private observeThumbStrip(): void {
    if (this.thumbRO) return;
    const el = this.thumbStripRef?.nativeElement
      ?? (this.el?.nativeElement?.querySelector('.thumb-strip') as HTMLElement | null);
    if (!el || typeof ResizeObserver === 'undefined') return;
    this.thumbRO = new ResizeObserver(() => {
      this.updateThumbsHasMore();
      // O callback do RO pode rodar fora da zona do Angular → força o change detection.
      try { this.cdRef.detectChanges(); } catch { /* view pode ter sido destruída */ }
    });
    this.thumbRO.observe(el);
  }

  private onStart() {
    // alert("começoou")
  }
  private onEnd(detail: GestureDetail) {
    const { type: _type, currentX: _currentX, deltaX, velocityX: _velocityX } = detail;

    try {
      if (detail == undefined || detail == null || deltaX < 75) {
        return;
      }
      console.log('onEnd', detail);
      this.dismiss();

    } catch (error) {
      console.error(JSON.stringify(error), error);
    }
  }

  ionViewWillEnter() {
    if (this.platform.is('android')) {
      this.backButton = this.platform.backButton.subscribe(() => {
        this.dismiss();
      });
    }

    this.route.queryParamMap.subscribe(params => {
      this.selfiesApproved = params.get('selfiesApproved') === 'true';
    });

    // Reseta o sliderReady para forçar recriação do componente
    this.sliderReady = false;
    
    // Garante que o estado do slider seja inicializado corretamente
    // Usa a mesma lógica do feed: verifica se está na superLikedList
    if (this.userData && !this.userData.match) {
      const isSuperLiked = this.superLikedList.includes(this.userData._id.$oid);
      const isLiked = this.userData.alreadyLiked;
      
      if (isSuperLiked) {
        // Prioriza super like sobre like (super like também marca como liked)
        this.userData.sliderState = SliderState.SUPERLIKE;
      } else if (isLiked) {
        // Se foi curtido, mantém LIKE
        this.userData.sliderState = SliderState.LIKE;
      } else {
        // Se não foi curtido nem superliked, garante que o estado seja IDLE
        this.userData.sliderState = SliderState.IDLE;
      }
      
      // Marca o slider como pronto para ser renderizado após um pequeno delay
      // Isso garante que o sliderState está definido antes do componente ser criado
      setTimeout(() => {
        this.sliderReady = true;
        this.cdRef.detectChanges();
      }, 0);
    }
  }

  /**
   * Inicializa o estado do slider, garantindo que o componente está pronto
   */
  private initializeSliderState(): void {
    if (!this.sliderComponent || !this.userData || this.userData.match) {
      return;
    }

    // Verifica se o componente slider está realmente pronto (tem os métodos necessários)
    if (!this.sliderComponent.getSuperLikePosition || !this.sliderComponent.getLikePosition) {
      // Se não estiver pronto, tenta novamente após um delay
      setTimeout(() => {
        this.initializeSliderState();
      }, 100);
      return;
    }

    // Garante que o estado do userData está correto
    // Usa a mesma lógica do feed: verifica se está na superLikedList
    const isSuperLiked = this.superLikedList.includes(this.userData._id.$oid);
    const isLiked = this.userData.alreadyLiked;
    
    if (isSuperLiked) {
      // Prioriza super like sobre like (super like também marca como liked)
      this.userData.sliderState = SliderState.SUPERLIKE;
    } else if (isLiked) {
      this.userData.sliderState = SliderState.LIKE;
    } else {
      this.userData.sliderState = SliderState.IDLE;
      if (this.sliderComponent) {
        this.sliderComponent.forceReset();
      }
    }
  }

  ionViewDidEnter() {
    this.schedulePhotoHint('next');
    // Garante que o sliderState está definido antes de renderizar o componente
    if (this.userData && !this.userData.match) {
      const isSuperLiked = this.superLikedList.includes(this.userData._id.$oid);
      const isLiked = this.userData.alreadyLiked;
      
      if (isSuperLiked) {
        this.userData.sliderState = SliderState.SUPERLIKE;
      } else if (isLiked) {
        this.userData.sliderState = SliderState.LIKE;
      } else {
        this.userData.sliderState = SliderState.IDLE;
      }
      
      // Marca o slider como pronto para ser renderizado
      this.sliderReady = true;
      this.cdRef.detectChanges();
      
      // Aguarda o componente ser renderizado e então aplica o estado
      setTimeout(() => {
        if (this.sliderComponent && this.userData && !this.userData.match) {
          const isSuperLiked = this.superLikedList.includes(this.userData._id.$oid);
          const isLiked = this.userData.alreadyLiked;
          
          if (isSuperLiked) {
            this.sliderComponent.setState(SliderState.SUPERLIKE, false);
          } else if (isLiked) {
            this.sliderComponent.setState(SliderState.LIKE, false);
          }
        }
      }, 100);
      
      // Aplica novamente com delay maior para garantir
      setTimeout(() => {
        if (this.sliderComponent && this.userData && !this.userData.match) {
          const isSuperLiked = this.superLikedList.includes(this.userData._id.$oid);
          const isLiked = this.userData.alreadyLiked;
          
          if (isSuperLiked) {
            this.sliderComponent.setState(SliderState.SUPERLIKE, false);
          } else if (isLiked) {
            this.sliderComponent.setState(SliderState.LIKE, false);
          }
        }
      }, 300);
    }
  }

  async openModalAvocado() {
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    const modal = await this.modalCtrl.create({
      component: AvocadoModalComponent,
      componentProps: {
        userData: this.me,
      },
      cssClass: 'custom-class-modal',
      backdropDismiss: true
    });

    this.unregisterFunction = this.platform.backButton.subscribeWithPriority(10, () => {
      this.dismissModal(modal)
    });

    await modal.present();

    const { data: _data } = await modal.onDidDismiss();
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }
  private async dismissModal(modal: HTMLIonModalElement) {
    if (modal) {
      await modal.dismiss();
      this.unregisterFunction?.unsubscribe();
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }
  }

  isLargerText(value: string) {
    return (value.length >= 30 ? true : false);
  }

  isLargestText(value: string) {
    return (value.length >= 50 ? true : false);
  }


  async vibrate() {
    if (this.isAndroid) {
      console.log('Will call vibrate');
      // this.vibration.vibrate(30);
      await Haptics.vibrate({ duration: 35 });
    }
  }

  openFullScreen(aPicture: string) {
    console.log('openFullScreen. aPicture: ' + aPicture);
    if (aPicture == PicturesPage.noImage || aPicture == PicturesPage.gray || aPicture == PicturesPage.loading) {
      return;
    }
    const _options = {
      share: false, // default is false
      closeButton: true, // default is true
      copyToReference: true, // default is false
      headers: "",  // If it is not provided, it will trigger an exception
      piccasoOptions: {} // If it is not provided, it will trigger an exception
    };
    // this.photoViewer.show(aPicture, (this.userData.firstName + ((this.userData.age != null) ? ', ' + this.userData.age : '')), options);

  }


  private loadMyImages() {

    // Reseta o estado de lazy loading das miniaturas ao (re)montar as fotos.
    this.thumbLoaded = [];

    let picnum: number;
    let picCount: number = 0;
    for (picnum = 0; picnum < 9; picnum++) {
      const aPic: string = "picture" + picnum;
      if (this.userData[aPic] != null) {
        const aPicIndex = picCount;
        picCount++;
        console.log('has picture' + picnum);
        console.log('this.userData[aPic].$oid: ' + this.userData[aPic].$oid);

        const aPicture = this.userService.getImageURL(this.userData[aPic].$oid); // this.soulService.getBaseURL() + '/soul/image/' + this.userData[aPic].$oid;

        this.pictures[aPicIndex] = aPicture;

        // download in background

        const _aFile = aPic + '.jpg';

        continue;

      }
    }

  }

  private createFileName(index: number) {
    return 'picture' + index + '.jpg';
  }

  private preparePhotos() {

    if (this.userData.firstPic != null) {
      this.pictures.push(this.userData.firstPic);
    }
    let picnum: number;
    let picCount: number = 0;
    for (picnum = 0; picnum < 9; picnum++) {
      const aPic: string = "picture" + picnum;
      if (this.userData[aPic] != null) {
        const aPicIndex = picCount;
        picCount++;
        console.log('has picture' + picnum);
        console.log('hthis.userData[aPic].$oid: ' + this.userData[aPic].$oid);

        // download in background
        const aPicture = this.userService.getImageURL(this.userData[aPic].$oid); //this.soulService.getBaseURL() + '/soul/image/' + this.userData[aPic].$oid;
        let _aFile = this.userData[aPic].$oid + '.jpg';
        if (aPicIndex == 0) {
          // profile picture
          _aFile = this.userData?._id.$oid + '.jpg';
          this.userData.firstPic = aPicture;
        }
        this.pictures[aPicIndex] = aPicture;

        continue;

      }
    }

    console.log('this.pictures.length: ' + this.pictures.length);
    if (this.pictures.length == 0) {
      this.pictures.push(PicturesPage.noImage);
    } else if (this.pictures[0] == PicturesPage.gray || this.pictures[0] == PicturesPage.loading) {
      this.pictures[0] = PicturesPage.noImage;
    }

    // Reseta o cache de "formato antigo" ao (re)montar as fotos; onActivePhotoLoaded recalcula
    // por foto conforme cada imagem exibida carrega.
    this.pictureIsLegacy = [];
    this.activePhotoIsLegacy = false;

    // Setinha "há mais fotos": robusto a timing/cache e a muitas fotos que carregam
    // devagar. Liga o ResizeObserver (mede após o layout) assim que a tira existir e
    // recalcula em alguns momentos até ela renderizar.
    [0, 200, 500, 1000, 2000].forEach((ms) => setTimeout(() => {
      this.observeThumbStrip();
      this.updateThumbsHasMore();
    }, ms));
    this.schedulePhotoHint('next');
  }

  public dismiss() {
    document.getElementById("contentDiv")?.classList.add('animation');
    // role 'recadinhoSent' avisa o chat (quando aberto de lá) para recarregar as mensagens.
    this.modalCtrl.dismiss(this.liked ? "liked" : null, this.recadinhoSent ? 'recadinhoSent' : undefined);
  }

  private loadView() {


    if (this.userData.gender != null) {
      this.gender = (this.gender == 'male') ? 'Male' : 'Female';

    } else {
      // Shouldn't happen
    }

    if (this.userData.diet != null && this.userData.diet != '') {
      if (this.userData.diet == 'vegan') {
        this.diet = this.translate.instant('vegan');
      } else if (this.userData.diet == 'vegetarian') {
        this.diet = this.translate.instant('vegetarian');
      } else {
        this.diet = this.translate.instant('working');
      }


    }

    if (this.userData.since) {
      const elapsed = getDietSinceElapsed(this.userData.since);
      this.timeElapsed = elapsed.value.toString();
      this.timeUnit = this.translate.instant(elapsed.unit);
      this.userData.timeStr = ` ${this.translate.instant('for')} ${this.timeElapsed} ${this.timeUnit}`;
    }

    const dietText: string = this.translate.instant('dietLifestyle') + (this.userData.diet != null ? this.translate.instant(this.userData.diet) : '') + (this.userData.timeStr != null ? this.userData.timeStr : '');
    this.dietTextSize = dietText.length;
    //alert(this.dietTextSize);
    const lastSeenText: string = this.translate.instant('lastSeen') + (this.userData.distance != null ? this.userData.distance : '0 miles') + this.translate.instant('fromYou');
    this.lastSeenTextSize = lastSeenText.length;
    //alert(this.lastSeenTextSize);


    console.log('profileDisplay - Will set the distance');
    // App 3.2+/web-2.4+: backend may return distance (km) and no location; else compute from location
    if (this.userData.distance != null && (this.userData.location == null || !this.userData.location?.coordinates)) {
      const distanceStr = String(this.userData.distance);
      const isAlreadyFormatted = distanceStr.includes('miles') || 
                                 distanceStr.includes('kilometers') ||
                                 distanceStr.includes(this.translate.instant('miles')) ||
                                 distanceStr.includes(this.translate.instant('kilometers')) ||
                                 distanceStr.includes(this.translate.instant('within1Mile')) ||
                                 distanceStr.includes(this.translate.instant('within1Kilometer'));
      
      if (!isAlreadyFormatted) {
        const isKm = this.me?.distanceUnit != null && this.me.distanceUnit === 'km';
        const distanceKm = this.userService.parseBackendDistanceKm(this.userData.distance);
        this.userData.distance = this.userService.formatDistanceFromKm(distanceKm, isKm);
      }
    } else {
      this.userData.distance = this.userService.getDistance(this.me, this.userData);
    }

  }

  ionViewWillLeave() {
    this.dismissPhotoHint();
    if (this.platform.is('android')) {
      if (this.backButton) {
        this.backButton.unsubscribe();
      }
    }
    this.thumbRO?.disconnect();
    this.thumbRO = undefined;
  }

  async showModalAlertNeedPictureToLike() {
    // Reseta a foto e a bolinha do swiper imediatamente quando o alert for apresentado
    // Garante que a bolinha volte para o centro (IDLE)
    if (this.userData) {
      // Se o perfil não estava curtido/superliked, reseta para IDLE
      if (!this.userData.alreadyLiked && !this.userData.alreadySuperLiked) {
        this.userData.sliderState = SliderState.IDLE;
      }
      this.resetSliderAndPhoto(true);
    }

    const alert = this.alertCtrl.create({
      subHeader: this.translate.instant('youNeedAtLeastOnePictureBeforeYouCanLike'),
      buttons: [{
        text: this.translate.instant('cancel'),
        handler: () => {
          console.log('cancel clicked');
          return;
        }
      },
      {
        text: this.translate.instant('uploadNow'),
        handler: async () => {
          console.log('Upload now clicked');
          const modal = this.modalCtrl.create({ component: ProfilePage, componentProps: { "showAvocadoClubIndicator": this.me.showAvocadoClubIndicator && this.purchaseServiceProvider.isPremium(this.me) } });
          (await modal).onDidDismiss().then((_data) => {
            Preferences.get({ key: 'USER_DATA' }).then((val) => {
              val = val.value ? JSON.parse(val.value) : null;
              this.me = val;
              this.userHasPicture = this.userService.checkUserHasPicture(this.me);
            });
          });

          (await modal).present();
          return;
        }
      }
      ]

    });

    (await alert).present();
  }

  async superLike() {
    console.log('Super Like clicked');
    this.vibrate();
    if (this.howOthersSeeMe) {
      // If displaying myself in "How Others will see me", just return
      return;
    }

    if (this.userHasPicture) {
        const modal = this.modalCtrl.create({
          component: SuperLikeModalComponent,
          componentProps: {
            userData: this.me,
            theSoul: this.userData,
            srcIconSuperLike: 'assets/imgs/orangeStar.svg',
          },
          cssClass: 'custom-class-modal',
          backdropDismiss: true
        });
        (await modal).onDidDismiss().then(async (val) => {
          console.log('Data returned from SuperLikeModalComponent: ' + JSON.stringify(val.data));

          if (val.data == 'cancelled' || val.data == undefined || val.data == 'undefined') {
            // Restaura o perfil se foi ocultado pelo hideProfileImmediately
            this.restoreProfileIfHidden();
            return;
          }

          if (val.data !== 'confirmed') {
            return;
          }

          const msg = '';

          const loader = this.loadingCtrl.create({
            message: this.translate.instant('sendingSuperLike')
          });
          (await loader).present();


          const theObs = this.userService.superLikeSoul(this.me._id.$oid, this.userData?._id.$oid, msg, this.me);

          theObs.subscribe(async data => {
            console.log('superLikeSoul subscribe entered');
            console.log('data = ' + JSON.stringify(data));
            (await loader).dismiss();
            if ('{ok}' == data) {
              //register event of like + superLike (like is once per device)
              this.analytics.registerEvent(AnalyticsService.superLikeEvent);
              // Once per device for all analytics sinks (PostHog/Adjust/GA4/Meta) by design.
              this.analytics.registerEvent(AnalyticsService.likeEvent, true);

              console.log("! Analytics 'like + superlike' event sent !");

              this.me.coins--;
              Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.me) }).then((_val) => {
                console.log('userdata with reduced coins stored');
              });

              if (this.userData.likesMe) {
                // There's a match!
                //register match event
                this.analytics.registerEvent(AnalyticsService.matchEvent);
                console.log("! Analytics 'match' event sent !");

                this.userData.match = true;
                this.itsAMatch();
              }
              if (!this.userData.alreadyLiked) {
                this.liked = true;
              }
              this.userData.alreadyLiked = true;
              this.userData.alreadySuperLiked = true;
              this.util.presentTopToastGreen(this.toastCtrl, this.translate.instant('superLikeSentSuccesfully'), 4000);

              Preferences.get({ key: 'ASKED_FOR_APP_REVIEW_AFTER_FIRST_LIKE' }).then((val) => {
                val = val.value ? JSON.parse(val.value) : null;
                if (this.isNative && !val) {
                  setTimeout(() => this.util.showAlertRateNow());
                  Preferences.set({ key: 'ASKED_FOR_APP_REVIEW_AFTER_FIRST_LIKE', value: JSON.stringify(true) }).then((_val) => {
                    console.log("askedForAppReviewAfterFirstLike saved to DB")
                  });
                }
              })

            }
          },
            async err => {
              (await loader).dismiss();
              this.util.showToastUnableToConnect(this.toastCtrl);
              console.log('Error: ' + JSON.stringify(err));
            });
        });


        (await modal).present();
    } else {
      this.showModalAlertNeedPictureToLike();
    }

  }

  like() {
    console.log('like clicked');
    this.vibrate();
    if (this.howOthersSeeMe) {
      return;
    }

    if (this.userHasPicture) {

      const theObs = this.userService.likeSoul(this.me._id.$oid, this.userData?._id.$oid, this.me);

      theObs.subscribe(data => {
        console.log('likeSoul subscribe entered');
        console.log('data = ' + JSON.stringify(data));

        //

        this.liked = true;

        if (this.userData.likesMe) {
          // There's a match!
          this.userData.match = true;
          this.itsAMatch();
          // A flag será definida quando o modal de match for fechado
        } else {
          // Sem match, definir flag imediatamente para animar ao voltar
          this.me.animateLikeFilter = true;
          Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.me) }).then(() => {
            console.log("animateLikeFilter flag saved to USER_DATA");
            // Emitir evento após salvar
            setTimeout(() => {
              this.eventService.publish('animate-like-filter', {});
            }, 500);
          });
        }
        this.userData.alreadyLiked = true;

        Preferences.get({ key: 'ASKED_FOR_APP_REVIEW_AFTER_FIRST_LIKE' }).then((val) => {
          val = val.value ? JSON.parse(val.value) : null;

          if (this.isNative && !val) {
            setTimeout(() => this.util.showAlertRateNow())
            Preferences.set({ key: 'ASKED_FOR_APP_REVIEW_AFTER_FIRST_LIKE', value: JSON.stringify(true) }).then((_val) => {
              console.log("askedForAppReviewAfterFirstLike saved to DB")
            });
          }
        })
      },
        err => {
          console.log('Error: ' + JSON.stringify(err));
        })

    } else {
      this.showModalAlertNeedPictureToLike();
    }

  }

  async itsAMatch() {
    this.vibrate();

    const modal = await this.modalCtrl.create({ component: VegMatchPage, componentProps: { me: this.me, otherSoul: this.userData }, showBackdrop: false, cssClass: 'VegMatch-content' });

    modal.onDidDismiss().then((val) => {
      console.log('Data returned from chat modal: ' + JSON.stringify(val.data));
      
      // Quando fecha o modal de match, definir flag para animar filtro ao voltar para home
      this.me.animateLikeFilter = true;
      Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.me) }).then(() => {
        console.log("animateLikeFilter flag saved after match dismissed");
        // Emitir evento após salvar
        setTimeout(() => {
          this.eventService.publish('animate-like-filter', {});
        }, 500);
      });
    });

    modal.present();
  }

  /** Galeria inline: tocar numa miniatura troca a foto exibida no slot grande (posição da foto 2). */
  setGalleryPhoto(index: number) {
    this.dismissPhotoHint();
    this.galleryIndex = index;
    this.fitContain = false; // cada foto começa no 4:5
    // Mostra imediatamente o valor cacheado (evita flicker); onActivePhotoLoaded corrige
    // quando a nova imagem carregar.
    this.activePhotoIsLegacy = this.pictureIsLegacy[index] === true;
    if (index > 0) {
      this.schedulePhotoHint('prev');
    }
  }

  /** Tap na foto: metade direita → próxima foto; metade esquerda → foto anterior. */
  onPhotoTap(ev: MouseEvent): void {
    if (!this.pictures || this.pictures.length <= 1) return;
    const el = ev.currentTarget as HTMLElement;
    const rect = el.getBoundingClientRect();
    const x = ev.clientX - rect.left;
    if (x > rect.width / 2) {
      this.setGalleryPhoto(Math.min(this.galleryIndex + 1, this.pictures.length - 1));
    } else {
      this.setGalleryPhoto(Math.max(this.galleryIndex - 1, 0));
    }
  }

  get photoHintPeekUrl(): string {
    if (!this.photoHintDirection || !this.pictures || this.pictures.length <= 1) {
      return '';
    }
    const peekIndex = this.photoHintDirection === 'next' ? this.galleryIndex + 1 : this.galleryIndex - 1;
    return this.pictures[peekIndex] || '';
  }

  private schedulePhotoHint(direction: 'next' | 'prev'): void {
    if (this.photoHintAlreadySeenOnDevice) {
      return;
    }
    if (!this.pictures || this.pictures.length <= 1 || this.photoHintShown[direction]) {
      return;
    }
    if (direction === 'next' && this.galleryIndex !== 0) {
      return;
    }
    if (direction === 'prev' && this.galleryIndex === 0) {
      return;
    }
    this.clearPhotoHintTimer();
    this.photoHintTimer = setTimeout(() => {
      this.photoHintShown[direction] = true;
      this.photoHintDirection = direction;
      this.persistPhotoHint();
      try { this.cdRef.detectChanges(); } catch { /* view destruída */ }
      this.photoHintTimer = setTimeout(() => this.dismissPhotoHint(), 2500);
    }, direction === 'next' ? 800 : 450);
  }

  private readStoredPhotoHint(): boolean {
    try {
      return localStorage.getItem(this.photoHintStorageKey) === 'true';
    } catch {
      return false;
    }
  }

  private persistPhotoHint(): void {
    try {
      localStorage.setItem(this.photoHintStorageKey, 'true');
    } catch {
      // ignore quota / private mode
    }
  }

  private dismissPhotoHint(): void {
    this.photoHintDirection = null;
    this.clearPhotoHintTimer();
  }

  private clearPhotoHintTimer(): void {
    if (this.photoHintTimer) {
      clearTimeout(this.photoHintTimer);
      this.photoHintTimer = null;
    }
  }

  /** (imageLoadedEvent) da foto principal: lê a proporção da imagem REALMENTE EXIBIDA e decide
   *  se o botão "ver foto inteira" aparece. 4:5 (≈0.8) = formato novo (cropado) → esconde; qualquer
   *  outra proporção = formato antigo → mostra. Cache por índice (cada foto tem status próprio,
   *  não contamina as outras). Ler o <img> exibido é confiável (mesma imagem que aparece). */
  public onActivePhotoLoaded(): void {
    const idx = this.galleryIndex;
    const img = this.el?.nativeElement?.querySelector('.picture-main app-loading-spinner img') as HTMLImageElement | null;
    if (!img || !img.naturalHeight) { return; }
    const legacy = Math.abs((img.naturalWidth / img.naturalHeight) - 0.8) > 0.03;
    this.pictureIsLegacy[idx] = legacy;
    this.activePhotoIsLegacy = legacy;
    try { this.cdRef.detectChanges(); } catch { /* view destruída */ }
  }

  /** Alterna entre a foto 4:5 cropada e a foto inteira (sem corte). Ao mudar, o
   *  container (loading-spinner) assume a proporção real e a tela reajusta ícones/espaços. */
  toggleFit(): void {
    this.fitContain = !this.fitContain;
  }

  /**
   * Recadinho (fase 1: só o modal). O envio real (curtida automática + 1 cenoura)
   * será ligado na próxima etapa.
   */
  /** Abre o modal de escrita do Elogio para uma foto específica (índice de exibição; 1ª foto = 0). */
  async openRecadinho(photoIndex: number = 0) {
    if (this.howOthersSeeMe) {
      return;
    }
    // O backend espera o ObjectId da foto (pictureId), não o índice.
    const photoId = this.util.getPictureOid(this.userData, photoIndex);
    const modal = await this.modalCtrl.create({
      component: RecadinhoPage,
      componentProps: {
        theSoul: this.userData,
        alreadyLiked: !!this.userData?.match,
        myPic: this.me?.firstPic,
        me: this.me,
        photoId: photoId,
        // Miniatura da foto elogiada (varia por índice no perfil).
        photoUrl: this.pictures?.[photoIndex] ?? null,
      },
      // Bottom sheet parcial (estilo Bumble): pega só parte da tela, fundo escurecido.
      breakpoints: [0, 0.5, 0.85],
      initialBreakpoint: 0.5,
      handle: false,
      cssClass: 'recadinho-sheet',
      backdropDismiss: true,
    });
    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data?.recadinho) {
      await this.sendRecadinho(this.userData, data.recadinho, data.photoId);
    }
  }

  /**
   * Envia o Elogio (Compliment) pelo backend (sendMessage recadinho=true): o servidor faz
   * a curtida automática, cobra 1 cenoura/spark e envia o email. Só trata as respostas.
   */
  private async sendRecadinho(aSoul: any, texto: string, photoId?: any) {
    this.userService.sendMessage(this.me?._id.$oid, aSoul._id.$oid, texto, this.me, undefined, true, photoId)
      .subscribe(async (data: any) => {
        if (data === '{No Coins}') {
          const modal = await this.modalCtrl.create({
            component: ComplimentModalComponent,
            componentProps: { userData: this.me, theSoul: aSoul },
            cssClass: 'custom-class-modal',
            showBackdrop: true,
            backdropDismiss: true,
          });
          await modal.present();
          return;
        }
        if (data === '{not ok}' || data == null) {
          this.util.showTopToastUnableToConnect(this.toastCtrl);
          return;
        }
        // Sucesso: curtida + cobrança feitas no servidor.
        this.recadinhoSent = true;
        this.util.presentToast(this.toastCtrl, this.translate.instant('recadinhoSent'), 3000);
      });
  }

  async chat() {
    console.log('chat clicked');
    if (this.howOthersSeeMe) {
      return;
    }

    const modal = this.modalCtrl.create({ component: ChatPage, componentProps: { me: this.me, otherSoul: this.userData, fromProfileDisplay: true }, showBackdrop: true });

    (await modal).onDidDismiss().then((val) => {
      console.log('Data returned from chat modal: ' + JSON.stringify(val));


      if (val.data == 'logout') {
        this.modalCtrl.dismiss('logout');
        return;
      }

      if (val.data == 'shouldRefreshList') {
        this.matchService.loadMatches(false);
      }

      if (val.data == 'initValidationProfile') {
        this.openValidation()
      }
    });


    (await modal).present();
  }

  removeSoul() {
    console.log('removeSoul');
    this.presentActionSheet();
    //this.presentConfirmRemove(soulIndex);
  }

  private async presentActionSheet() {
    const actionSheet = this.actionSheetCtrl.create({
      buttons: [
        {
          text: this.translate.instant('exclude'),
          handler: () => {
            console.log('Exclude clicked');
            this.presentConfirmExclude();
          }
        },
        {
          text: this.translate.instant('hide'),
          handler: () => {
            console.log('Hide clicked');
            this.hide();
          }
        },
        {
          text: this.translate.instant('block'),
          role: 'destructive',
          handler: () => {
            console.log('Block clicked');
            this.presentConfirmBlock();
          }
        },
        {
          text: this.translate.instant('reportAbuse'),
          role: 'destructive',
          handler: () => {
            console.log('Report clicked');
            this.presentConfirmReport();
          }
        },
        {
          text: this.translate.instant('cancel'),
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    (await actionSheet).present();

  }

  hide() {
    // Oculta o perfil imediatamente quando swipe para baixo chegar ao final
    this.hideProfileImmediately(true, 'down');
    
    // Chama o serviço de hide
    this.userService.hideSoul(this.me, this.userData).subscribe((result) => {
      console.log('hideSoul: ' + JSON.stringify(result));
    },
      err => {
        console.log('Error: ' + JSON.stringify(err));
      });
  }

  /**
   * Oculta o perfil imediatamente quando o swipe chegar ao final
   * Similar ao hideProfileImmediately da home page
   */
  private hideProfileImmediately(closeModal: boolean = true, swipeDirection?: 'left' | 'right' | 'down'): void {
    const element = document.getElementById('contentDiv');
    if (element) {
      // Escolhe a animação baseada na direção do swipe
      let animationClass = 'hide-inwards'; // padrão
      
      if (swipeDirection === 'left') {
        animationClass = 'swipe-left-animation-smooth';
      } else if (swipeDirection === 'right') {
        animationClass = 'swipe-right-animation-smooth';
      } else if (swipeDirection === 'down') {
        animationClass = 'swipe-down-animation-smooth';
      }
      
      element.classList.add(animationClass);
    }
    
    // Marca o perfil como oculto
    this.userData.isHidden = true;
    
    // Só fecha o modal se especificado (para permitir cancelamento)
    if (closeModal) {
      // Usa um delay para permitir que a animação seja visível
      setTimeout(() => {
        this.modalCtrl.dismiss('removed');
      }, 550); // Delay para corresponder à duração da animação (500ms)
    }
  }

  /**
   * Restaura o perfil se foi ocultado pelo hideProfileImmediately no profileDisplay
   * Fecha o modal e volta para a home para que o perfil reapareça
   */
  private restoreProfileIfHidden(): void {
    if (this.userData.isHidden) {
      // Remove a flag de oculto para que o perfil reapareça na home
      this.userData.isHidden = false;
      
      // Remove classes de animação que possam ter sido aplicadas
      const element = document.getElementById('contentDiv');
      if (element) {
        element.classList.remove('swipe-left-animation-smooth', 'swipe-right-animation-smooth', 'swipe-down-animation-smooth', 'hide-inwards');
        element.style.transform = '';
        element.style.opacity = '';
        element.style.transition = '';
      }
    }

    // Se a ação não foi completada (modal foi cancelado), reseta o estado do slider para IDLE
    if (!this.userData.alreadySuperLiked && !this.userData.alreadyLiked) {
      this.userData.sliderState = SliderState.IDLE;
    }

    // Reseta foto e slider
    this.resetSliderAndPhoto();
  }

  /**
   * Aplica animação de drag na foto
   */
  private applyPhotoDrag(dx: number, maxRange?: number): void {
    if (!this.photoRef?.nativeElement) return;

    const limit = Math.max(maxRange ?? 180, 1);
    const constrained = Math.max(Math.min(dx, limit), -limit);
    const rotation = (constrained / limit) * 7;

    const photoElement = this.photoRef.nativeElement;
    photoElement.classList.add('dragging');
    photoElement.style.transition = 'transform 0s';
    photoElement.style.transform = `translateX(${constrained}px) rotate(${rotation}deg)`;
  }

  /**
   * Reseta a animação da foto
   */
  private resetPhotoDrag(animate = true): void {
    if (!this.photoRef?.nativeElement) return;

    const photoElement = this.photoRef.nativeElement;
    photoElement.classList.remove('dragging');
    photoElement.style.transition = animate ? 'transform 0.25s ease-out' : 'transform 0s';
    photoElement.style.transform = '';

    if (animate) {
      setTimeout(() => {
        if (photoElement.isConnected) {
          photoElement.style.transition = '';
        }
      }, 260);
    } else if (photoElement.isConnected) {
      photoElement.style.transition = '';
    }
  }

  /**
   * Reseta foto e slider
   */
  private resetSliderAndPhoto(animate = false): void {
    setTimeout(() => {
      this.resetPhotoDrag(animate);

      if (this.sliderComponent && !this.userData.match) {
        const targetState = this.userData?.sliderState ?? SliderState.IDLE;
        this.sliderComponent.setState(targetState, false);
      }
    }, 0);
  }

  /**
   * Aplica efeitos visuais durante o drag do slider no profileDisplay
   */
  onDragProgress(event: {direction: 'left' | 'right' | 'down' | null, progress: number}): void {
    // Reseta animações prévias antes de aplicar novos efeitos
    this.resetProfileVisualState();

    if (!event) {
      this.resetPhotoDrag();
      return;
    }

    const { direction, progress } = event;
    const likeRange = this.sliderComponent?.getLikePosition?.() ?? 150;
    const superRange = Math.abs(this.sliderComponent?.getSuperLikePosition?.() ?? -150);

    if ((direction === 'left' || direction === 'right') && progress >= 0) {
      const range = direction === 'right' ? likeRange : superRange;
      const dx = (direction === 'right' ? 1 : -1) * range * Math.min(progress, 1);
      this.applyPhotoDrag(dx, Math.max(likeRange, superRange));
    } else {
      this.resetPhotoDrag();
    }
  }

  /**
   * Chamado quando o drag termina no profileDisplay
   */
  onDragEnd(_event: any): void {
    // Reseta o estado visual do modal para garantir que volte ao normal
    this.resetProfileVisualState();
    this.resetPhotoDrag();
  }

  /**
   * Reseta o estado visual do modal para o normal
   */
  private resetProfileVisualState(): void {
    const element = document.getElementById('contentDiv');
    if (element) {
      // Remove todas as classes de animação
      element.classList.remove('swipe-left-animation-smooth', 'swipe-right-animation-smooth', 'swipe-down-animation-smooth', 'hide-inwards');
      
      // Reset dos estilos inline
      element.style.transform = '';
      element.style.opacity = '';
      element.style.transition = '';
    }
  }

  public onSliderMudou(novoEstado: SliderState): void {
    const SLIDER_ANIMATION_DELAY = 320;

    // Verifica se o usuário tem foto antes de executar super like ou like
    if (!this.userHasPicture) {
      this.showModalAlertNeedPictureToLike();
      return;
    }

    if (novoEstado === SliderState.SUPERLIKE && this.superLikedList.includes(this.userData._id.$oid)) {
      this.userData.sliderState = SliderState.SUPERLIKE;
      return;
    }     else if (novoEstado === SliderState.SUPERLIKE) {
      // Para super like, aguarda a animação da bolinha/foto finalizar
      setTimeout(() => {
        // Não fecha o modal imediatamente (permite cancelamento)
        this.hideProfileImmediately(false, 'left');
        this.superLike();
      }, SLIDER_ANIMATION_DELAY);
      return;
    }
    else if (novoEstado === SliderState.LIKE) {
      setTimeout(() => {
        // Ocultar perfil após a animação da bolinha
        this.hideProfileImmediately(true, 'right');
        this.like();
      }, SLIDER_ANIMATION_DELAY);
      // A animação será disparada via evento quando voltar para a home
    }
  }

  async presentConfirmExclude() {
    const alert = this.alertCtrl.create({
      header: this.translate.instant('confirmExclusion'),
      message: this.translate.instant('userWillNotAppearAnymoreMsg'),
      buttons: [
        {
          text: this.translate.instant('cancel'),
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: this.translate.instant('exclude'),
          handler: () => {
            console.log('Exclude clicked');
            const soulIdToExclude = this.userData?._id.$oid;
            const theObs = this.userService.excludeSoul(this.me._id.$oid, soulIdToExclude, this.me);

            theObs.subscribe(data => {
              console.log('excludeSoul subscribe entered');
              console.log('data = ' + JSON.stringify(data));
              this.matchService.ensureLoggedInAndLoad();
              this.modalCtrl.dismiss('removed');
            },
              err => {
                this.util.showToastUnableToConnect(this.toastCtrl);
                console.log('Error: ' + JSON.stringify(err));
              })
          }
        }
      ]
    });
    (await alert).present();
  }


  async presentConfirmBlock() {
    const alert = this.alertCtrl.create({
      header: this.translate.instant('confirmBlock'),
      message: this.translate.instant('confirmBlockMsg'),
      buttons: [
        {
          text: this.translate.instant('cancel'),
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: this.translate.instant('block'),
          handler: () => {
            console.log('Block clicked');
            const soulIdToExclude = this.userData?._id.$oid;
            const theObs = this.userService.blockSoul(this.me._id.$oid, soulIdToExclude, this.me);

            theObs.subscribe(data => {
              console.log('excludeSoul subscribe entered');
              console.log('data = ' + JSON.stringify(data));
              this.matchService.ensureLoggedInAndLoad();
              this.modalCtrl.dismiss('removed');
            },
              err => {
                this.util.showToastUnableToConnect(this.toastCtrl);
                console.log('Error: ' + JSON.stringify(err));
              })
          }
        }
      ]
    });
    (await alert).present();
  }

  async presentConfirmReport() {
    const alert = this.alertCtrl.create({
      header: this.translate.instant('confirmReport'),
      message: this.translate.instant('confirmReportMsg'),
      inputs: [
        {
          value: 'stalking',
          label: this.translate.instant('stalking'),
          type: 'checkbox'
        },
        {
          value: 'abusivePictures',
          label: this.translate.instant('abusivePictures'),
          type: 'checkbox'
        },
        {
          value: 'fake',
          label: this.translate.instant('fake'),
          type: 'checkbox'
        },
        {
          value: 'commercial',
          label: this.translate.instant('commercial'),
          type: 'checkbox'
        },
        {
          value: 'underAged',
          label: this.translate.instant('underAged'),
          type: 'checkbox'
        },
        {
          value: 'aggressiveChating',
          label: this.translate.instant('aggressiveChating'),
          type: 'checkbox'
        },
        {
          value: 'other',
          label: this.translate.instant('other'),
          type: 'checkbox'
        }
      ],
      buttons: [
        {
          text: this.translate.instant('cancel'),
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: this.translate.instant('report'),
          handler: async (reportReasons) => {
            console.log('Report clicked: ' + JSON.stringify(reportReasons));

            const alert = this.alertCtrl.create({
              header: this.translate.instant('anythingToAdd'),
              message: this.translate.instant('reportExplanationMsg'),
              inputs: [
                {
                  name: 'textExplanation',
                  placeholder: this.translate.instant('explanationPlaceholder'),
                }
              ],
              buttons: [
                {
                  text: this.translate.instant('cancel'),
                  role: 'cancel',
                  handler: () => {
                    console.log('Cancel clicked');
                  }
                },
                {
                  text: this.translate.instant('report'),
                  handler: (textExplanation) => {
                    console.log('Report clicked: ' + JSON.stringify(textExplanation));
                    reportReasons.push(textExplanation);
                    console.log('reportReasons: ' + JSON.stringify(reportReasons));

                    const soulIdToExclude = this.userData?._id.$oid;
                    console.log('soulIdToReport: ' + soulIdToExclude);

                    const theObs = this.userService.reportSoul(this.me._id.$oid, soulIdToExclude, JSON.stringify(reportReasons), this.me);


                    theObs.subscribe(async data => {
                      console.log('reportSoul subscribe entered');
                      console.log('data = ' + JSON.stringify(data));

                      const alert = this.alertCtrl.create({
                        header: this.translate.instant('thanksForReporting'),
                        subHeader: this.translate.instant('userWillBeInvestigated'),
                        buttons: ['Ok']
                      });
                      (await alert).present();
                    },
                      err => {
                        this.util.showToastUnableToConnect(this.toastCtrl);
                        console.log('Error: ' + JSON.stringify(err));
                      })

                  }
                }
              ]
            });
            (await alert).present();


          }
        }
      ]
    });
    (await alert).present();
  }

  setHeight() {

    const heightValueFoot = this.userData.height * 0.0328084 | 0;  //cm -> feet
    const heightValueInch = ((this.userData.height * 0.0328084) - heightValueFoot) * 12 | 0; //feet -> inches

    return ((this.userData.height / 100) + " m / " + heightValueFoot + "'" + heightValueInch);
  }

  lookingForOptions() {
    if (this.userData.lookingFor != null) {
      const optionsChosen: any = [];

      this.userData.lookingFor.forEach((option: any) => {
        optionsChosen.push(this.translate.instant(option));
      });

      return optionsChosen.join(", ");
    } else {
      return "";
    }
  }

  swipeEvent(e: any) {
    try {
      console.log('swiped');
      if (e == undefined || e == null || e.deltaX < 0) {
        // slide left
        return;
      }
      console.log(JSON.stringify(e));
      this.dismiss();

      // Check direction left to right
      // Check if works on other places this is opened
      // Can we have a better animation?
      //this.dismiss();

    } catch (error) {
      console.error(JSON.stringify(error), error);
    }
  }

  async openValidateProfileComponent() {

    if (this.userData?.userValidated) {
      const modal = this.modalCtrl.create({ component: ProfileAlreadyValidatedComponent, cssClass: 'custom-class-modal' });
      (await modal).present();

    } else {
      const modal = this.modalCtrl.create({ component: ValidateProfileComponent, componentProps: { me: this.userData }, cssClass: 'custom-class-modal' });
      (await modal).present();

      (await modal).onDidDismiss().then((val) => {
        if (val && val.data === "openValidation") {
          this.openValidation();
        }
      });
    }

  }

  async openValidation() {

    Preferences.get({ key: 'USER_DATA' }).then(async (val: any) => {
      val = val.value ? JSON.parse(val.value) : null;
      if (val) {
        this.userData = val;

        if (this.userData?.userValidated) {
          const modal = this.modalCtrl.create({ component: ProfileAlreadyValidatedComponent, cssClass: 'custom-class-modal' });
          (await modal).present();
        } else {
          if (!this.userData?.hasValidPhone && !localStorage.getItem('skipStep') && !this.userData?.hasValidPoseSelfie) {
            this.router.navigate(['/home-check-profile'], { queryParams: { originValidation: '/tabs/my-profile-display' } });
          } else {
            if (this.userData?.hasValidPoseSelfie && !this.userData?.userValidated) {
              this.validateProfile(true);
            } else {
              this.validateProfile(false);
              this.router.navigate(['/instructions-check-profile'], { queryParams: { originValidation: '/tabs/my-profile-display' } });
            }
          }
        }
      }
    })
  }

  validateProfile(verifyIsCompleted: boolean) {

    console.log(this.userData)
    const theObs = this.userService.validateProfile(this.userData);
    theObs.subscribe(async response => {
      const data = JSON.parse(response);

      if (data.result === 'notok' && verifyIsCompleted) {
        const modal = await this.modalCtrl.create({
          component: ChangeProfilePhotoComponent,
          componentProps: {
            me: this.userData
          },
          cssClass: 'custom-class-modal'
        });
        modal.present();

        (await modal).onDidDismiss().then((val) => {
          if (val.data !== undefined && val.data !== null && val.data === 'editPhoto') {
            this.editPhotoProfile()
          }
        });
        return;
      } else if (data.result === 'ok') {
        this.userData.userValidated = true;
        return;
      } else {
        this.userData.userValidated = false;
        return;
      }
    },
      err => {
        this.util.showToastUnableToConnect(this.toastCtrl);
        console.log('Error: ' + JSON.stringify(err));
      })
  }

  async editPhotoProfile() {
    const modal = await this.modalCtrl.create({
      component: ProfilePage,
      cssClass: 'confirm-password-modal',
    });

    (await modal).onDidDismiss().then((_val) => {
      Preferences.get({ key: 'USER_DATA' }).then((val: any) => {
        val = val.value ? JSON.parse(val.value) : null;
        if (val) {
          this.userData = val;

          if (localStorage.getItem('profileApproved') === 'profileApproved') {
            this.validateProfile(true)
          }
        }
      })

    });

    modal.present();
  }

  async profileShare() {
    const modal = await this.modalCtrl.create({
      component: ShareProfileComponent,
      componentProps: {
        userId: this.userData?._id.$oid
      },
      cssClass: 'custom-class-modal'
    });
    modal.present();
  }

  isSuperLiked(aSoul: any): boolean {
    if (!aSoul || !aSoul._id || !aSoul._id.$oid) {
      return false;
    }
    return this.superLikedList.includes(aSoul._id.$oid);
  }

  getGenderDisplayText(genderValue: string): string {
    if (!genderValue) return '';

    switch (genderValue) {
      case 'female':
        return this.translate.instant('woman');
      case 'male':
        return this.translate.instant('man');
      case 'other':
        return this.translate.instant('nonBinaryGenderDiverse');
      default:
        return genderValue; // Return as-is if it's a custom description
    }
  }

}
